export const pintendreTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_sectors: 'Secteurs',
  breadcrumb_current: 'Pintendre',
  hero_h1: "Couvreur à Pintendre : toiture résidentielle et dépendances",
  hero_subtitle: "Spécialistes des grandes propriétés à Pintendre. Maisons, garages détachés, granges. Soumission gratuite en 2h.",
  hero_cta: "Demander ma soumission Pintendre",
  hero_stat_1: 'Plusieurs dizaines de mises en relation à Pintendre',
  hero_stat_2: 'Certifié',
  hero_stat_3: 'Grandes propriétés',

  // Connaitre le quartier
  quartier_h2: "Pintendre : grandes propriétés et caractère champêtre",
  quartier_p1: "Pintendre, c'est un secteur semi-rural de Lévis où les lots font facilement 10 000 pi² et plus. On y trouve majoritairement des maisons unifamiliales avec garages détachés, ateliers, granges converties et autres dépendances. Les rangs Saint-David et Pointe-Lévy concentrent aussi des fermettes et anciennes maisons de ferme avec plusieurs structures à entretenir.",
  quartier_p2: "Ça demande un couvreur capable de gérer des projets multi-bâtiments : maison + garage 24x32 + grange convertie en atelier + solarium. Beaucoup de propriétaires optent pour la tôle pour sa durabilité et son esthétique champêtre qui s'intègre bien au caractère rural du secteur. On connaît ce type de chantier, et on sait coordonner les travaux pour minimiser les dérangements.",

  // Profil toitures
  profil_h2: "Les particularités à Pintendre",
  profil_1_title: 'MULTI-BÂTIMENTS',
  profil_1_desc: "Maison + garage + atelier + dépendances. Soumissions globales avec rabais volume. Un seul couvreur pour toute la propriété, un seul chantier coordonné.",
  profil_2_title: 'TÔLE POPULAIRE',
  profil_2_desc: "Caractère champêtre + grandes surfaces = tôle dominante. 40 % de nos projets à Pintendre incluent au moins une structure en tôle, souvent en agrafes cachées.",
  profil_3_title: 'BÂTIMENTS AGRICOLES',
  profil_3_desc: "Anciennes granges et fermettes converties en résidences secondaires ou ateliers. Toitures historiques à restaurer avec respect du caractère rural.",

  // Services
  services_h2: "Tous nos services à Pintendre",
  service_1: "Réfection maison bardeau ou tôle",
  service_2: "Toiture tôle garage détaché",
  service_3: "Toit plat membrane (annexes)",
  service_4: 'Restauration bâtiments agricoles',
  service_5: 'Soumissions multi-bâtiments',
  service_6: 'Déneigement grandes surfaces',

  // Prix
  prix_h2: "Prix moyens à Pintendre 2026",
  prix_table_type: 'Type de bâtiment',
  prix_table_price: 'Fourchette 2026',
  prix_row_1_type: 'Bungalow 1 400-1 700 pi² (bardeau)',
  prix_row_1_price: '8 500 $ – 13 000 $',
  prix_row_2_type: 'Cottage 1 900-2 400 pi² (bardeau)',
  prix_row_2_price: '12 000 $ – 18 000 $',
  prix_row_3_type: 'Garage 24x32 (tôle)',
  prix_row_3_price: '5 500 $ – 9 000 $',
  prix_row_4_type: 'Grange 30x40 (tôle)',
  prix_row_4_price: '8 000 $ – 14 000 $',
  prix_row_5_type: 'Projet global maison + 2 dépendances',
  prix_row_5_price: '18 000 $ – 32 000 $',
  prix_note: "Rabais volume disponible pour projets multi-bâtiments. Soumission précise après inspection sur place.",

  // Projets récents
  projets_h2: "Projets récents à Pintendre",
  projet_1_title: 'Rang Saint-David',
  projet_1_desc: "Maison + garage en tôle agrafes cachées, juillet 2025",
  projet_2_title: 'Pointe-Lévy',
  projet_2_desc: "Restauration grange convertie, juin 2025",
  projet_3_title: 'Chemin Vire-Crêpe',
  projet_3_desc: "Bardeau architectural 2 200 pi², septembre 2025",

  // Témoignage
  temoignage_quote: "On a une maison sur le rang Saint-David avec un garage détaché de 24 par 32, les deux construits dans les années 80. On hésitait à faire les travaux en deux temps, mais Marc-Antoine a proposé une soumission globale pour les deux bâtiments avec un rabais de volume. La maison a été refaite en bardeau architectural et le garage en tôle agrafes cachées. L'équipe a travaillé 5 jours et tout était coordonné. Pas de va-et-vient, pas de dérangement répété. C'est exactement ce qu'on cherchait pour une propriété comme la nôtre. On recommande sans hésiter.",
  temoignage_author: 'Robert et Diane L.',
  temoignage_rue: 'Rang Saint-David',
  temoignage_city: 'Pintendre',
  temoignage_detail: "Maison et garage refaits, juillet 2025",

  // Zones proches
  zones_h2: 'On dessert aussi',
  zone_levis: 'Lévis centre',
  zone_charny: 'Charny',
  zone_st_jean: 'Saint-Jean-Chrysostome',
  zone_saint_romuald: 'Saint-Romuald',

  // CTA Final
  cta_h2: "Votre projet à Pintendre, simple ou multi-bâtiments",
  cta_subtitle: 'Soumission gratuite en 2h, expertise grandes propriétés, garantie 10 ans.',
  cta_button: "Demander ma soumission",
  cta_phone: '418-476-9950',

  // Shared
  phone_number: '418-476-9950',
};

export default pintendreTranslations;